<template>

  <div class="flex w-full h-screen bg-gray-50">
    <div class="flex-1 w-full overflow-y-auto">
      <Topbar />
        <div class="p-8" style="margin-top:64px;">
          <div class="flex justify-center items-center mb-6 relative">
              <div class="absolute left-0">
                  <RouterLink to="/employee" class="flex-none text-red-500 rounded-xl hover:text-red-700 cursor-pointer"> Назад </RouterLink>
              </div>
              <h2 class="text-2xl font-bold flex items-center gap-2">
                  <i class="pi pi-users" style="font-size: 2rem"></i>  Табель учета рабочего времени (факт)
              </h2>
          </div>
      
          <Toast />
          <div class="card">
              <DataTable 
                  editMode="row" dataKey="id" v-model:editingRows="editingRows" @row-edit-save="onRowEditSave"
                  :value="workScheduleFact" :paginator="true" :loading="loading" :rows="10" :rowsPerPageOptions="[5, 10]"
                  ref="workScheduleFactTable" size="small" resizableColumns  columnResizeMode="fit"  showGridlines scrollable
                  :filters="filters" filterDisplay="menu" :globalFilterFields="['name', 'position']"
              >
                  <template #empty> Нету данных за выбранный месяц </template>
                  <template #header>
                      <div class="flex justify-between">
                          <div class="flex flex-wrap gap-2 items-center justify-between">
                              <IconField>
                                  <InputIcon> <i class="pi pi-search" /> </InputIcon>
                                  <InputText v-model="filters['global'].value" placeholder="Поиск..." class="h-11" />
                              </IconField>
                              <FloatLabel variant="on">
                                  <label for="on_label" class="z-10"> Месяц </label>
                                  <DatePicker v-model="selectedMonth" :invalid="!selectedMonth" view="month" size="small" dateFormat="yy-mm" inputId="on_label" showIcon iconDisplay="input" />
                              </FloatLabel>
                          </div>
                          <div class="flex">
                              <Button icon="pi pi-upload" severity="info" @click="exportCSV($event)" />
                          </div>
                      </div>
                  </template>
              
                  <Column field="name"     header="ФИО" class="text-sm z-10" style="min-width: 8rem" frozen/>
                  <Column field="position" header="Должность" class="text-sm" style="min-width: 8rem"/>
                  <Column field="payment_method" header="Способ оплаты" class="text-center text-sm" style="min-width: 6rem"/>
                  <Column field="tariff" header="Тариф" class="text-center text-sm" style="min-width: 6rem"/>
              
                  <Column
                    v-for="col in columns"
                    :key="col.field"
                    :field="col.field"
                  >
                      <template #header>
                          <div class="flex flex-col items-center">
                              <span class="text-sm">{{ col.weekday }}</span>
                              <span class="text-xs font-bold">{{ col.header }}</span>
                          </div>
                      </template>
                      <template #body="{ data, field }">
                          <div class="flex flex-col items-center">
                              <Button :icon="data[field] === 1 ? 'pi pi-briefcase' : 'pi pi-times'" 
                                      :severity="data[field] === 1 ? 'info' : 'secondary'" disabled/>
                          </div>
                      </template>
                      <template #editor="{ data, field }">
                          <div class="flex flex-col items-center">
                              <Button :icon="data[field] === 1 ? 'pi pi-check' : 'pi pi-building'"
                                      :severity="data[field] === 1 ? 'success' : 'secondary'"
                                      @click="data[field] = data[field] === 1 ? 0 : 1"
                              />
                          </div>
                      </template>
                  </Column>
                  <Column field="total_days" header="Итого смен" class="text-center text-sm" style="min-width: 6rem" alignFrozen="right" frozen>
                      <template #body={data}>
                          <div class="flex flex-col items-center">
                              {{ data.total_days }}
                          </div>
                      </template>
                  </Column>
                  <Column field="total_sum"  header="План ФОТ" class="text-center text-sm" style="min-width: 6rem" alignFrozen="right" frozen>
                      <template #body={data}>
                          <div class="flex flex-col items-center">
                              {{ data.total_sum.toLocaleString() + " " + data.currency }}
                          </div>
                      </template>
                  </Column>
                  <ColumnGroup type="footer">
                      <Row>
                          <Column class=" !bg-white" align-frozen="left" footer="Итого:" frozen/><Column/><Column/><Column/>
                          <Column footerStyle="text-align:center"
                              v-for="(value, day) in totalPerDay"
                                  :key="day"
                                  :footer="value"
                                  :class="totalChangeClass(value)"
                          >
                          </Column>
                          <Column class="!bg-white" alignFrozen="right" :footer="totalDays" footerStyle="text-align:center" frozen/>
                          <Column class="!bg-white" v-if="totalSum" alignFrozen="right" :footer="totalSum.toLocaleString()"  footerStyle="text-align:center" frozen/>
                      </Row>
                  </ColumnGroup>
              </DataTable>
          </div>
        </div>
        </div>
    </div>  
</template>

<script setup>
import axios from '../lib/axios'
import { ref, onMounted, watch, computed } from 'vue'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'
import { useToast } from 'primevue/usetoast'
import { useRouter } from 'vue-router'
import Toast from 'primevue/toast'
import dayjs from 'dayjs'

const toast = useToast()
const loading = ref(false)
const router = useRouter()

const selectedMonth = ref(dayjs().format('YYYY-MM'))
const workScheduleFact = ref([])
const workScheduleFactTable = ref()
const columns = ref([])
const editingRows = ref([])
const totalPerDay = ref()
const totalDays = ref()
const totalSum = ref()

// filters
const filters = ref({
    'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
})

const initFilters = () => {
    filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    }
}
initFilters()

const clearFilter = () => {
    initFilters()
}

const month = computed(() => {
    return dayjs(selectedMonth.value).format('YYYY-MM')
})

watch(selectedMonth, (newValue, oldValue) => {
    fetchWorkScheduleFact()
    return dayjs(newValue).format('YYYY-MM')
})

// get data
const fetchWorkScheduleFact = (event) => {
    loading.value = true
    axios.get('/api/get-work-schedule-fact?date=' +  month.value + '-01')
        .then(response => {
            let fact = response.data.work_schedule_fact;
            totalPerDay.value = response.data.total_per_day;
            totalDays.value = response.data.total_days;
            totalSum.value = response.data.total_sum;

            if (fact.length > 0) {
                const firstDays = fact[0].days;

                columns.value = Object.entries(firstDays).map(([date, info]) => ({
                  field: date,
                  weekday: info.weekday,
                  header: info.header,
                  date: date
                }));

            }
        
            workScheduleFact.value = fact.map((row) => {
                return {
                    id: row.id,
                    employee_id: row.employee.id,
                    name: row.employee.name,
                    position: row.employee.position,
                    tariff: row.employee.tariff,
                    payment_method: row.employee.payment_method,
                    total_days: row.total_days,
                    total_sum: row.total_sum,
                    currency: row.employee.currency,
                    ...Object.fromEntries(
                        Object.entries(row.days).map(([date, info]) => [date, info.value])
                    )
                };
            });
            loading.value = false
        })
        .catch(error => {
            toast.add({severity:'error', summary: 'Ошибка!', detail: error, life: 3000})
        });
};

const totalChangeClass = (value) => {
    if (value > 0) return 'text-success'
    return 'text-danger'
}

const onRowEditSave = async (event) => {
    const { newData, index } = event

    try {
        await axios.put(`/api/work-schedule-fact/${event.data.id}`, event.newData)
        workScheduleFact.value[index] = newData
        fetchWorkScheduleFact()
        toast.add({severity:'success', summary: 'Успешно!', detail: 'Изменения сохранены', life: 3000})
    }   catch   {
        toast.add({severity:'error', summary: 'Ошибка!', detail: 'Не удалось сохранить изменения', life: 3000})
    }
}

const exportCSV = () => {
    workScheduleFactTable.value.exportCSV({ selectionOnly: false});
}

onMounted(() => {
    fetchWorkScheduleFact()
})
</script>